module.exports = __webpack_public_path__ + "static/thumb-iluminacion-e95519ff43688cc87064170bc57a8a3a.jpg";